import {createReducer} from '../utility'




export const paymentReport = createReducer({},{
    "FETCH_PAYMENTS_REPORTS_SUCCESSFUL"(state, {data}){
        if(data){
            return {
                ...state,
                report: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})